/** @flow */
import Opportunity from 'common/modules/proposition/domain/opportunity';
import type { Dispatch, GetState } from 'statsradio/types/Store';
import { sendMessage } from 'statsradio/modules/notifications/actions/notificationActions';
import { getStation, getToken } from '../../authentication/session/reducers/sessionReducer';
import { estimate, fetch } from '../services/SalesEstimationApi';
import { getHistory } from '../selectors/salesSelectors';
import { updateProgress, markSalesNotificationAsRead } from './salesNotificationsActions';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';
import DateRange from '../../../../common/domain/DateRange';

export const ESTIMATE_SALES_ASYNC_REQUEST = 'sales/ESTIMATE_SALES_ASYNC_REQUEST';
export const ESTIMATE_SALES_ASYNC_SUCCESS = 'sales/ESTIMATE_SALES_ASYNC_SUCCESS';
export const ESTIMATE_SALES_ASYNC_FAILURE = 'sales/ESTIMATE_SALES_ASYNC_FAILURE';

export const FETCH_SALES_ESTIMATION_REQUEST = 'sales/FETCH_SALES_ESTIMATION_REQUEST';
export const REMOVE_FROM_NEW_ESTIMATION = 'sales/REMOVE_FROM_NEW_ESTIMATION';
export const FETCH_SALES_ESTIMATION_ERROR = 'sales/FETCH_SALES_ESTIMATION_ERROR';

export function estimateAsync(toEstimate: Opportunity[], centralMarket: ?CentralMarket, metricsDateRange: ?DateRange) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: ESTIMATE_SALES_ASYNC_REQUEST });

    try {
      const token = getToken(getState());
      const callSign = getStation(getState());

      const progress = await estimate(token, callSign, toEstimate, centralMarket, metricsDateRange);

      const progressRequest = { request: toEstimate, progress };
      dispatch({ type: ESTIMATE_SALES_ASYNC_SUCCESS, progressRequest });

      dispatch(updateProgress(progress));
      dispatch(sendMessage({ type: 'SUBSCRIBE_SALES_PROGRESS', reference: progress.reference }));

      return progressRequest;
    } catch (e) {
      dispatch({ type: ESTIMATE_SALES_ASYNC_FAILURE });
      throw e;
    }
  };
}

export function fetchEstimation(reference: string) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_SALES_ESTIMATION_REQUEST });

    try {
      const currentHistory = getHistory(getState());

      let estimation = currentHistory.find(e => e.reference === reference);
      if (!estimation) {
        const token = getToken(getState());
        const callSign = getStation(getState());
        estimation = await fetch(token, callSign, reference);
      }

      dispatch({ type: REMOVE_FROM_NEW_ESTIMATION, estimation });
      dispatch(markSalesNotificationAsRead(estimation.reference));
      return estimation;
    } catch (e) {
      dispatch({ type: FETCH_SALES_ESTIMATION_ERROR, error: e });
      return undefined;
    }
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/actions/salesEstimationActions.js